export const DRIVE_PROMPT_TIMEOUT = 5 * 60 * 1000;

export const THINKING_MESSAGE_TYPE = 'thinking' as const;

/** Shown while a response is streaming until the orchestrator emits a waiting signal */
export const THINKING_STATUS_TEXT = 'Thinking…';

/** First-tier stall / waiting copy (orchestrator `onWaiting('working')`) */
export const DEFAULT_STREAMING_STATUS_TEXT = 'Working on your response…';

export const TEXT_WRAP_SX = {
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  overflowWrap: 'break-word',
} as const;

export const WELCOME_MESSAGES = [
  'Coffee refill or data refill?',
  'Pump the numbers?',
  "What's the question behind the question?",
  "Let's see what the data says.",
  'Let\'s find the "why" in the numbers.',
  'Time to turn data into answers.',
  'Ready for insights?',
  'Where should we start digging?',
  "What's the data trying to tell us?",
  "Let's connect the dots.",
  "Let's get curious with the data.",
  "What's worth knowing right now?",
  "Let's zoom in on what matters.",
] as const;
